import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import type { RoomPreviewDto } from '@chromarble/shared-types';
import { ErrorNote, Screen } from '../components/ui';
import { api } from '../services/api';
import { roomTypeLabel } from '@chromarble/crew-adapter';

export default function JoinPage() {
  const { roomId = '' } = useParams();
  const [params] = useSearchParams();
  const invite = params.get('invite') ?? '';
  const navigate = useNavigate();
  const [preview, setPreview] = useState<RoomPreviewDto | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.preview(roomId, invite).then(
      (r) => setPreview(r.room),
      (e) => setError(e),
    );
  }, [roomId, invite]);

  const join = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.join(roomId, invite);
      navigate(`/rooms/${roomId}`, { replace: true });
    } catch (e) {
      setError(e);
      setBusy(false);
    }
  };

  return (
    <Screen title="게임 초대" back="/">
      {!preview && !error && <p className="muted">초대 정보를 확인하는 중…</p>}
      {preview && (
        <section className="card" data-testid="join-preview">
          <h2>{preview.title}</h2>
          <p>
            방장 {preview.hostNickname} · {roomTypeLabel(preview.roomType)} · {preview.memberCount}/{preview.maxPlayers}명
          </p>
          {preview.joinable ? (
            <button className="btn" onClick={join} disabled={busy} data-testid="join-submit">
              {busy ? '참가 중…' : '참가하기'}
            </button>
          ) : (
            <p className="error">지금은 참가할 수 없는 방입니다 ({preview.status}).</p>
          )}
        </section>
      )}
      <ErrorNote error={error} />
    </Screen>
  );
}
